import React from 'react';
import { Button, KIND, SIZE } from 'baseui/button';
import { EXPORT_FORMAT } from '../constants';
import { ExportFormat } from '../types';
import useStyles from '../useStyles';

interface IExportActionsProps {
	canExport: boolean;
	isLoading: boolean;
	onExport: (format: ExportFormat) => void;
}

const ExportActions: React.FC<IExportActionsProps> = ({ canExport, isLoading, onExport }) => {
	const { classes } = useStyles();
	if (!canExport) return <span className={classes.muted}>You do not have permission to export this data.</span>;
	return (
		<div className={classes.actionsRow}>
			<Button kind={KIND.secondary} size={SIZE.compact} disabled={isLoading} onClick={() => onExport(EXPORT_FORMAT.JSON)}>
				Export JSON
			</Button>
			<Button kind={KIND.secondary} size={SIZE.compact} disabled={isLoading} onClick={() => onExport(EXPORT_FORMAT.CSV)}>
				Export CSV
			</Button>
		</div>
	);
};

export default ExportActions;
